import { getPropsForClickTracking } from "../../utils/tracking";

<if(input.model)>
  $ const { index, selectionState, isVisible, watchListItems, handleWatchListItemToggle } = input;
  $ const { card, sponsored, signalling, trackingList, hotnessSignal, productRating, sellerName, sellerRating, listingFormat } = input.model;
  $ const { title, action, image, displayPrice, listingId, distance } = card;

  <li class=["left-rail-item-wrapper", isVisible ? "left-rail-item-wrapper-visible" : "left-rail-item-wrapper-hidden"]>
    <item-watchlist model=card handleWatchListItemToggle=handleWatchListItemToggle watchListItems=watchListItems/>
    <a
      data-testid="left-rail-item"
      class=`left-rail-item left-rail-item__${selectionState}`
      on-mouseenter("onItemHover", index, listingId || "")
      on-mouseleave("onUnhoverItem")
      on-focus("onItemHover", index, listingId || "")
      on-blur("onUnhoverItem")
      rel="noreferrer"
      target="_blank"
      title=(title?.textSpans?.[0].text)
      href=action?.URL
      ...getPropsForClickTracking(trackingList)
    >
      <div class="left-rail-item-image-container">
        <img class="left-rail-item-image" src=image?.URL alt=(title?.textSpans?.[0].text)>
      </div>
      <div class="left-rail-item-content-container">
        <if(hotnessSignal)>
          <hotness-signal model=hotnessSignal/>
        </if>
        <p class="left-rail-item-title">
          <fe-textual-display model=title/>
        </p>
        <div class="left-rail-item-details">
          <fe-textual-display model=signalling/>
        </div>
        <item-seller-info productRating=productRating sellerName=sellerName sellerRating=sellerRating/>
        <div class="left-rail-item-price">
          <item-price-display displayPrice=displayPrice listingFormat=listingFormat/>
        </div>
        <if(distance)>
          <div class="left-rail-item-distance">
            <fe-textual-display model=distance/>
          </div>
        </if>
        <if(sponsored)>
          <div class="left-rail-item-sponsored-label">
            <fe-textual-display model=sponsored/>
          </div>
        </if>
      </div>
    </a>
  </li>
</if>
